import { createAction, props } from '@ngrx/store'

const SOURCE = '[Admin Project Feature]'

export const resetSchema = createAction(`${ SOURCE } resetSchema`)

export const setSchemaProperty = createAction(
    `${ SOURCE } setSchemaProperty`,
    props<{property: string; value: any}>()
)

export const setProjectProperty = createAction(
    `${ SOURCE } setProjectProperty`,
    props<{property: string; value: any}>()
)

export const setProjectActualizationProperty = createAction(
    `${ SOURCE } setProjectActualizationProperty`,
    props<{property: string; value: any}>()
)

export const setProjectDefaultProperty = createAction(
    `${ SOURCE } setProjectDefaultProperty`,
    props<{property: string; value: any}>()
)

export const setProjectOptionProperty = createAction(
    `${ SOURCE } setProjectOptionProperty`,
    props<{property: string; value: any}>()
)

export const setProjectRequestProperty = createAction(
    `${ SOURCE } setProjectRequestProperty`,
    props<{property: string; value: any}>()
)

export const setSchema = createAction(
    `${ SOURCE } setSchema`,
    props<{schema: any}>()
)

export const setSchemaJpv = createAction(
    `${ SOURCE } setSchemaJpv`,
    props<{anyJpv: boolean}>()
)

export const removeArea = createAction(
    `${ SOURCE } removeArea`,
    props<{area: any}>()
)

export const addConcernedSubject = createAction(
    `${ SOURCE } addConcernedSubject`,
    props<{subject: any}>()
)

export const removeConcernedSubject = createAction(
    `${ SOURCE } removeConcernedSubject`,
    props<{subject: any}>()
)

export const addSubjectKn = createAction(
    `${ SOURCE } addSubjectKn`,
    props<{subject: any}>()
)

export const addSubjectLpis = createAction(
    `${ SOURCE } addSubjectLpis`,
    props<{subject: any}>()
)

export const removeSubjectKn = createAction(
    `${ SOURCE } removeSubjectKn`,
    props<{subject: any}>()
)

export const removeSubjectLpis = createAction(
    `${ SOURCE } removeSubjectLpis`,
    props<{subject: any}>()
)

export const removeLv = createAction(
    `${ SOURCE } removeLv`,
    props<{lv: any}>()
)

export const addPars = createAction(
    `${ SOURCE } addPars`,
    props<{pars: any}>()
)

export const removePars = createAction(
    `${ SOURCE } removePars`,
    props<{pars: any}>()
)

export const updateAnyJpv = createAction(
    `${ SOURCE } updateAnyJpv`
)

// --- effects

export const addArea = createAction(
    `${ SOURCE } addArea`,
    props<{area: any}>()
)

export const addLv = createAction(
    `${ SOURCE } addLv`,
    props<{lv: any}>()
)

// ---

export const noAction = createAction(`${ SOURCE } No Action`)